export default __webpack_public_path__ + "static/media/partner_02.d1479711.png";